<template>
  <div class="file-select-container">
    <div style="position: relative;">
      <label>附件<v-icon small>attach_file</v-icon></label>
      <a v-if="editable" style="position: absolute;right: 0;" href="javascript: void(0)" @click="edit=!edit">{{ edit ? '取消' : '編輯' }}</a>
    </div>
    <!-- <v-container class="files-container" grid-list-xl>
      <v-layout row wrap>
        <v-flex xs6 sm4 md3 v-if="value.length === 0">
          <v-card>
            <div style="height: 150px;">
              <p class="center">未有附件</p>
            </div>
          </v-card>
        </v-flex>
        <v-flex xs6 sm4 md3 v-for="(file, index) in value" :key="index" v-else>
          <v-card class="file" @click="open(file.file)">
            <v-img
              :src="file.file"
              height="150px"
              contain
            ></v-img>
            <p class="file-name-container">{{ file.name }}</p>
            <v-btn v-if="edit" @click="removeFile(index)" small icon color="red" style="position: absolute;right: -15px;top: -15px;">
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-card>
        </v-flex>
        <v-flex xs6 sm4 md3 v-if="edit">
          <div style="height: 150px;position: relative;">
            <v-btn class="center" @click="showFileSelect = true" flat icon color="green" style="margin: 0;">
              <v-icon>add</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container> -->
    <div class="files-container">
      <div class="file-container button" v-if="edit">
        <v-btn class="center" @click="showFileSelect = true" flat icon color="green" style="margin: 0;">
          <v-icon>add</v-icon>
        </v-btn>
      </div>
      <div class="file-container" v-if="value.length === 0 && !edit">
        <v-card>
          <div style="height: 180px;">
            <p class="center">未有附件</p>
          </div>
        </v-card>
      </div>
      <template v-else>
        <div class="file-container" v-for="(file, index) in value" :key="`file_${index}`">
          <v-card class="file" @click="open(file.file)">
            <v-img
              :src="file.file"
              height="150px"
              contain
              v-if="file.content_type && file.content_type.match('image.*')"
            ></v-img>
            <div class="file-preview" v-else>
              <span>{{ file.file.split('.').pop() }}</span>
            </div>
            <p class="file-name-container">{{ file.name }}</p>
          </v-card>
          <v-btn v-if="edit" @click="removeFile(index)" small icon color="red" style="position: absolute;right: -10px;top: -10px;">
            <v-icon color="white">close</v-icon>
          </v-btn>
        </div>
      </template>
    </div>
    
    <core-file-select @close="showFileSelect=false" :value="this.value" @input="$emit('input', $event)" v-if="showFileSelect" />
  </div>
</template>

<script>
import CoreFileSelect from './CoreFileSelect'
import _ from 'lodash'

export default {
  props: {
    'value': {
      type: Array,
      default: () => []
    },
    'editable': {
      type: Boolean,
      default: true
    }
  },
  name: 'file-select-input',
  data() {
    return {
      edit: false,
      showFileSelect: false,
      loading: false,
    }
  },
  methods: {
    open(src) {
      window.open(src)
    },
    removeFile(index) {
      let files = _.cloneDeep(this.value)
      files.splice(index, 1)
      this.$emit('input', files)
    }
  },
  components: { CoreFileSelect }
}
</script>

<style>
.file-preview {
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  text-transform: uppercase;
  font-weight: bold;
  color: #e8e8e8;
}
</style>

<style scoped>
label {
  color: rgba(0,0,0,.54);
}
.file-select-container {
  position: relative;
}

.file-select-container .files-container {
  padding: 16px 0 10px;
}

.file-select-container .files-container .file-container {
  width: 24.8%;
  display: inline-block;
  position: relative;
  vertical-align: top;
}

.file-select-container .files-container .file-container.button {
    height: 180px;
}

@media screen and (max-width: 512px) {
  .file-select-container .files-container .file-container.button {
    width: 50px;
    height: 180px;
    margin-right: 20px;
  }
  .file-select-container .files-container .file-container  {
    width: 60%;
  }
  .file-select-container .files-container {
    white-space: nowrap;
    overflow-x: scroll;
  }
}

.file {
  margin: 10px;
  position: relative;
}
.file:hover {
  cursor: pointer;
}
.file-name-container {
  margin: 0;
  border-top: 1px solid lightgrey;
  padding: 5px;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  direction: rtl;
}
</style>



// WEBPACK FOOTER //
// src/components/FileSelectInput.vue